<!--

    Page Name :- Alert Modal
    Author: Sunny Khattri
    Description: This component is used for alert configuration
    Date: 25-06-2021

-->

<!-- <div class="app-modal modal " id="alertBoxModal" role="dialog" >
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header modal-hdr">
                <button type="button" class="close close-class-alert" data-dismiss="modal"  ><img src="assets/images/close-white.svg"></button>
                <div class="modal-hdr-txt" >{{ modalData.title }}</div>
            </div>

            <div class="modal-body">
                <div class="container-fluid">
                   <div class="modal-bind-text" >{{ modalData.description }}</div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="container-fluid">
                        <div class="col-xs-12 dis-in text-right">
                            <button class="btn btn-primary modal-save-btn bg-white text-center" id = "cancelBtn" data-dismiss="modal" >{{ modalData.actionButtonText }}</button>
                        
                            <button class="btn btn-primary modal-save-btn text-center" id="doneBtn" data-dismiss="modal">{{ modalData.actionButtonText }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="app-modal-backdrop"></div>
</div> -->


<div id="modal-content-wrapper">
    <header id="modal-header" class="model-header-btn" onselectstart='return false;'>
        <button type="button" class="close close-class-alert"   (click)="closeModal()" ><img src="assets/images/close-white.svg"></button>
        <h1 id="modal-title">{{ modelObject.title }}</h1>
    </header>
    <section id="modal-body">
        <p class="modal-body-paragraph" onselectstart='return false;' [innerHTML] ="modelObject.description"></p>
    </section>
    <footer id="modal-footer">
        <button mat-raised-button id="modal-action-button" onselectstart='return false;' *ngIf="modelObject.showSuccessBtn" (click)="actionFunction()">
            {{ modelObject.successText }}
        </button>
        <button mat-raised-button id="modal-cancel-button" onselectstart='return false;' *ngIf="modelObject.showFaliureBtn"  (click)="closeModal()">
            {{ modelObject.failureText}}
        </button>
    </footer>
</div>

<!--

End of Alert Modal
Page Name :- Alert Modal
Author: Pankaj Patil
Date: 21-06-2018

-->
